var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcrTests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8EEE1;}\n\t.st1{fill:#F08380;}\n\t.st2{fill:#AD5D58;}\n\t.st3{fill:#E87B75;}\n\t.st4{fill:#F4A09F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.6,229.4c48.6,0,87.9-39.4,87.9-87.9c0-48.6-39.4-87.9-87.9-87.9C93,53.6,53.7,93,53.7,141.5 C53.7,190,93,229.4,141.6,229.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 141,
    cy: 141.2,
    rx: 38.7,
    ry: 39.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.2,102.3c0.1-0.7,0.1-1.4,0.2-2.1c0.2-2.4,0.2-4.7,0.1-7c-1.2-1-2-2.5-2-4.2c0-3.1,2.5-5.6,5.5-5.6 c3.1,0,5.5,2.5,5.5,5.6c0,1.7-0.8,3.3-2,4.2c-0.1,2.1,0,4.5,0.1,7c0,0.7,0.1,1.4,0.2,2.1H137.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.2,180.1c0.1,0.7,0.1,1.4,0.2,2.1c0.2,2.4,0.2,4.7,0.1,7c-1.2,1-2,2.5-2,4.2c0,3.1,2.5,5.6,5.5,5.6 c3.1,0,5.5-2.5,5.5-5.6c0-1.7-0.8-3.3-2-4.2c-0.1-2.1,0-4.5,0.1-7c0-0.7,0.1-1.4,0.2-2.1H137.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M179.5,137.4c0.7,0.1,1.4,0.1,2,0.2c2.4,0.2,4.7,0.2,6.9,0.1c1-1.2,2.5-2,4.2-2c3.1,0,5.5,2.5,5.5,5.6 s-2.5,5.6-5.5,5.6c-1.7,0-3.2-0.8-4.2-2c-2.1-0.1-4.4,0-6.9,0.1c-0.7,0-1.4,0.1-2,0.2V137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.5,145.1c-0.7-0.1-1.4-0.1-2-0.2c-2.4-0.2-4.7-0.2-6.9-0.1c-1,1.2-2.5,2-4.2,2c-3.1,0-5.5-2.5-5.5-5.6 s2.5-5.6,5.5-5.6c1.7,0,3.2,0.8,4.2,2c2.1,0.1,4.4,0,6.9-0.1c0.7,0,1.4-0.1,2-0.2V145.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 135.5,
    cy: 124.5,
    rx: 14.7,
    ry: 14.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 135.5,
    cy: 124.5,
    rx: 11.1,
    ry: 11.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 146.5,
    cy: 159.9,
    rx: 11.1,
    ry: 11.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 146.5,
    cy: 159.9,
    rx: 7.4,
    ry: 7.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 126.3,
    cy: 148.7,
    rx: 9.2,
    ry: 9.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 126.3,
    cy: 148.7,
    rx: 5.5,
    ry: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.4,124.5c-0.6-2.4-2-6.8-5.5-11.2c-1.4-1.7-2.9-3.2-4.3-4.3l5.6-5.7c1.1,1.4,2.5,2.9,4.3,4.3 c4.3,3.5,8.7,5,11.1,5.6L113.4,124.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M168.7,158c0.6,2.4,2,6.8,5.5,11.2c1.4,1.7,2.9,3.2,4.3,4.3l-5.6,5.7c-1.1-1.4-2.5-2.9-4.3-4.3 c-4.3-3.5-8.7-5-11.1-5.6L168.7,158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M157.6,113.3c2.4-0.6,6.7-2.1,11.1-5.6c1.7-1.4,3.1-2.9,4.3-4.3l5.6,5.7c-1.4,1.1-2.9,2.5-4.3,4.3 c-3.5,4.4-4.9,8.8-5.5,11.2L157.6,113.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116.4,161.1l-3.1-3.1c-0.6,2.4-2,6.8-5.5,11.2c-1.4,1.7-2.9,3.2-4.3,4.3l5.6,5.7c1.1-1.4,2.5-2.9,4.3-4.3 c3.1-2.6,6.3-4,8.8-4.9c0.9-0.3,1.7-0.5,2.3-0.7L116.4,161.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 100.4,
    cy: 100.3,
    rx: 9.2,
    ry: 9.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 181.6,
    cy: 182.2,
    rx: 9.2,
    ry: 9.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 181.6,
    cy: 100.3,
    rx: 9.2,
    ry: 9.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 100.4,
    cy: 182.2,
    rx: 9.2,
    ry: 9.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 159.5,
    cy: 141.2,
    rx: 9.2,
    ry: 9.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 159.5,
    cy: 141.2,
    rx: 5.5,
    ry: 5.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcrTests);
export default __webpack_public_path__ + "static/media/PCR_tests.144017d12b35af773bedfd72016a7700.svg";
export { ForwardRef as ReactComponent };